import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "37",
  height: "36",
  fill: "none",
  viewBox: "0 0 37 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_14261_244535)\"><path fill=\"#F13E33\" d=\"M.5 0h36v36H.5z\"></path><path fill=\"#fff\" d=\"M8.375 14.005c0-1.634.635-3.171 1.794-4.332a6.07 6.07 0 0 1 4.324-1.798h14.132v3.118H14.493c-.799 0-1.55.313-2.122.885a3 3 0 0 0-.884 2.132l-.021 5.233c-.143 1.39-1.19 2.508-2.54 2.715l-.551.08zM8.375 28.125v-3.118h14.132c.799 0 1.556-.318 2.122-.886a3 3 0 0 0 .884-2.126l.005-4.963c0-1.48 1.101-2.762 2.557-2.985l.55-.085v8.033c0 1.633-.64 3.17-1.794 4.332a6.07 6.07 0 0 1-4.324 1.798z\"></path><path fill=\"#fff\" d=\"M20.342 22.048v-4.024l-1.842 2.2-1.842-2.2v4.024h-2.44v-7.927h2.313l1.969 2.55 1.974-2.55h2.308v7.927z\"></path></g><defs><clipPath id=\"clip0_14261_244535\"><rect width=\"36\" height=\"36\" x=\".5\" fill=\"#fff\" rx=\"6.75\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }